import React, { useState } from 'react';
import { bool, string } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { LINE_ITEM_CUSTOMER_COMMISSION, propTypes } from '../../util/types';
import classNames from 'classnames';
import InfoIcon from './InfoIcon';
import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

// Validate the assumption that the commission exists and the amount
// is zero or positive.
const isValidCommission = commissionLineItem => {
  return (
    commissionLineItem &&
    commissionLineItem.lineTotal instanceof Money &&
    commissionLineItem.lineTotal.amount >= 0
  );
};

const LineItemCustomerCommissionMaybe = props => {
  const {
    lineItems,
    isCustomer,
    marketplaceName,
    intl,
    hasCommissionLineItem,
    transaction,
  } = props;
  const metadata = transaction.attributes.metadata;

  const customerCommissionLineItem = lineItems.find(
    item => item.code === LINE_ITEM_CUSTOMER_COMMISSION && !item.reversal
  );
  const discountToApplyNow =
    metadata?.discountToApplyNow || customerCommissionLineItem?.discountToApplyNow;

  // If commission is passed it will be shown as a fee already reduces from the total price
  let commissionItem = null;

  if (isCustomer && customerCommissionLineItem) {
    if (!isValidCommission(customerCommissionLineItem)) {
      // eslint-disable-next-line no-console
      console.error('invalid commission line item:', customerCommissionLineItem);
      throw new Error('Commission should be present and the value should be zero or positive');
    }

    const commission = customerCommissionLineItem.lineTotal;

    const formattedCommission = commission ? formatMoney(intl, commission) : null;
    const [showInfo, setShowInfo] = useState(false);

    commissionItem = (
      <div
        onMouseOver={() => setShowInfo(true)}
        onMouseLeave={() => setShowInfo(false)}
        className={classNames(css.lineItem, hasCommissionLineItem)}
      >
        {hasCommissionLineItem && showInfo && (
          <InfoIcon
            lineItems={lineItems}
            value={<FormattedMessage id="OrderBreakdown.commissionFeeNote" />}
            showInfo={showInfo}
          />
        )}
        <span className={classNames(css.underLine, css.itemLabel)}>
          <FormattedMessage id="OrderBreakdown.commission" values={{ marketplaceName }} />
        </span>
        <p className={css.itemValue}>
          {/* {JSON.stringify(customerCommissionLineItem?.discountToApplyNow)} */}
          {/* {commission.amount > 0 && (
            <span className={classNames(css.underLine)}>{formattedCommission}</span>
          )} */}
          <span className={classNames(css.underLine)}>{formattedCommission}</span>
          &nbsp; &nbsp;
          {discountToApplyNow > 0 && (
            <span className={css.linethrow_red}>
              {discountToApplyNow && formatMoney(intl, new Money(discountToApplyNow, 'EUR'))}
            </span>
          )}
        </p>
      </div>
    );
  }

  return commissionItem;
};

LineItemCustomerCommissionMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  isCustomer: bool.isRequired,
  marketplaceName: string.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemCustomerCommissionMaybe;
